import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { OffeneGutachtenService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [OffeneGutachtenService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class OffeneGutachtenServiceModule {}
